import {
  INVOICE_SUB_AGENT_CREATE_FAIL,
  INVOICE_SUB_AGENT_CREATE_REQUEST,
  INVOICE_SUB_AGENT_CREATE_RESET,
  INVOICE_SUB_AGENT_CREATE_SUCCESS,
  INVOICE_SUB_AGENT_DELETE_FAIL,
  INVOICE_SUB_AGENT_DELETE_REQUEST,
  INVOICE_SUB_AGENT_DELETE_SUCCESS,
  INVOICE_SUB_AGENT_GET_FAIL,
  INVOICE_SUB_AGENT_GET_REQUEST,
  INVOICE_SUB_AGENT_GET_SUCCESS,
  INVOICE_SUB_AGENT_LIST_FAIL,
  INVOICE_SUB_AGENT_LIST_REQUEST,
  INVOICE_SUB_AGENT_LIST_SUCCESS,
  INVOICE_SUB_AGENT_UPDATE_FAIL,
  INVOICE_SUB_AGENT_UPDATE_REQUEST,
  INVOICE_SUB_AGENT_UPDATE_SUCCESS,
} from "../constants/invoiceSubAgentConstants";

export const subAgentInvoiceListReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_SUB_AGENT_LIST_REQUEST:
      return { loading: true };
    case INVOICE_SUB_AGENT_LIST_SUCCESS:
      return {
        loading: false,
        subagentInvoices: action.payload,
        subagentInvoiceTotal: action.total,
      };
    case INVOICE_SUB_AGENT_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const subAgentInvoiceCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_SUB_AGENT_CREATE_REQUEST:
      return { loading: true };
    case INVOICE_SUB_AGENT_CREATE_SUCCESS:
      return { loading: false, success: action.payload };
    case INVOICE_SUB_AGENT_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case INVOICE_SUB_AGENT_CREATE_RESET:
      return { loading: false, success: "" };
    default:
      return state;
  }
};

export const subAgentInvoiceGetReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_SUB_AGENT_GET_REQUEST:
      return { loading: true };
    case INVOICE_SUB_AGENT_GET_SUCCESS:
      return { loading: false, subagentInvoiceDet: action.payload };
    case INVOICE_SUB_AGENT_GET_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const subAgentInvoiceUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_SUB_AGENT_UPDATE_REQUEST:
      return { loading: true };
    case INVOICE_SUB_AGENT_UPDATE_SUCCESS:
      return { loading: false, success: action.payload };
    case INVOICE_SUB_AGENT_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const subAgentInvoiceDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_SUB_AGENT_DELETE_REQUEST:
      return { loading: true };
    case INVOICE_SUB_AGENT_DELETE_SUCCESS:
      return { loading: false, success: action.payload };
    case INVOICE_SUB_AGENT_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
